export default __webpack_public_path__ + "static/media/logo-facebook.1229e596.svg";